import {
    GET_PUSAT_OVERVIEW,
    GET_PUSAT_OVERVIEW_SUCCESS,
    GET_PUSAT_OVERVIEW_FAIL,
    GET_PROVINSI_OVERVIEW,
    GET_PROVINSI_OVERVIEW_SUCCESS,
    GET_PROVINSI_OVERVIEW_FAIL,
    GET_KABKOT_OVERVIEW,
    GET_KABKOT_OVERVIEW_SUCCESS,
    GET_KABKOT_OVERVIEW_FAIL,
    GET_KECAMATAN_OVERVIEW,
    GET_KECAMATAN_OVERVIEW_SUCCESS,
    GET_KECAMATAN_OVERVIEW_FAIL,

    GET_DOKUMEN_PROVINSI,
    GET_DOKUMEN_PROVINSI_SUCCESS,
    GET_DOKUMEN_PROVINSI_FAIL,
    GET_DOKUMEN_KABKOT,
    GET_DOKUMEN_KABKOT_SUCCESS,
    GET_DOKUMEN_KABKOT_FAIL,
    GET_DOKUMEN_KECAMATAN,
    GET_DOKUMEN_KECAMATAN_SUCCESS,
    GET_DOKUMEN_KECAMATAN_FAIL,
  } from "./actionTypes";
  
  const initialState = {
    dataPusatOverview: {
      loading: false,
      error: false,
      data: null,
    },
    dataProvinsiOverview: {
      loading: false,
      error: false,
      data: null,
    },
    dataKabkotOverview: {
      loading: false,
      error: false,
      data: null,
    },
    dataKecamatanOverview: {
      loading: false,
      error: false,
      data: null,
    },
    dataDokumenProvinsi: {
      loading: false,
      error: false,
      data: null,
    },
		dataDokumenKabkot: {
      loading: false,
      error: false,
      data: null,
    },
		dataDokumenKecamatan: {
      loading: false,
      error: false,
      data: null,
    },
  };
  
  const reducer = (state = initialState, action) => {
    switch (action.type) {
      // get table exco pusat
      case GET_PUSAT_OVERVIEW:
        return {
          ...state,
          dataPusatOverview: {
            ...state.dataPusatOverview,
            loading: true,
            error: false,
          },
        };
      case GET_PUSAT_OVERVIEW_SUCCESS:
        return {
          ...state,
          dataPusatOverview: {
            ...state.dataPusatOverview,
            loading: false,
            error: false,
            data: action.payload,
          },
        };
      case GET_PUSAT_OVERVIEW_FAIL:
        return {
          ...state,
          dataPusatOverview: {
            ...state.dataPusatOverview,
            loading: false,
            error: action.payload,
          },
      };
      case GET_PROVINSI_OVERVIEW:
        return {
          ...state,
          dataProvinsiOverview: {
            ...state.dataProvinsiOverview,
            loading: true,
            error: false,
          },
        };
      case GET_PROVINSI_OVERVIEW_SUCCESS:
        return {
          ...state,
          dataProvinsiOverview: {
            ...state.dataProvinsiOverview,
            loading: false,
            error: false,
            data: action.payload,
          },
        };
      case GET_PROVINSI_OVERVIEW_FAIL:
        return {
          ...state,
          dataProvinsiOverview: {
            ...state.dataProvinsiOverview,
            loading: false,
            error: action.payload,
          },
      };
      case GET_KABKOT_OVERVIEW:
        return {
          ...state,
          dataKabkotOverview: {
            ...state.dataKabkotOverview,
            loading: true,
            error: false,
          },
        };
      case GET_KABKOT_OVERVIEW_SUCCESS:
        return {
          ...state,
          dataKabkotOverview: {
            ...state.dataKabkotOverview,
            loading: false,
            error: false,
            data: action.payload,
          },
        };
      case GET_KABKOT_OVERVIEW_FAIL:
        return {
          ...state,
          dataKabkotOverview: {
            ...state.dataKabkotOverview,
            loading: false,
            error: action.payload,
          },
      };
      case GET_KECAMATAN_OVERVIEW:
        return {
          ...state,
          dataKecamatanOverview: {
            ...state.dataKecamatanOverview,
            loading: true,
            error: false,
          },
        };
      case GET_KECAMATAN_OVERVIEW_SUCCESS:
        return {
          ...state,
          dataKecamatanOverview: {
            ...state.dataKecamatanOverview,
            loading: false,
            error: false,
            data: action.payload,
          },
        };
      case GET_KECAMATAN_OVERVIEW_FAIL:
        return {
          ...state,
          dataKecamatanOverview: {
            ...state.dataKecamatanOverview,
            loading: false,
            error: action.payload,
          },
      };
      case GET_DOKUMEN_PROVINSI:
        return {
          ...state,
          dataDokumenProvinsi: {
            ...state.dataDokumenProvinsi,
            loading: true,
            error: false,
          },
        };
      case GET_DOKUMEN_PROVINSI_SUCCESS:
        return {
          ...state,
          dataDokumenProvinsi: {
            ...state.dataDokumenProvinsi,
            loading: false,
            error: false,
            data: action.payload,
          },
        };
      case GET_DOKUMEN_PROVINSI_FAIL:
        return {
          ...state,
          dataDokumenProvinsi: {
            ...state.dataDokumenProvinsi,
            loading: false,
            error: action.payload,
          },
      };
			case GET_DOKUMEN_KABKOT:
        return {
          ...state,
          dataDokumenKabkot: {
            ...state.dataDokumenKabkot,
            loading: true,
            error: false,
          },
        };
      case GET_DOKUMEN_KABKOT_SUCCESS:
        return {
          ...state,
          dataDokumenKabkot: {
            ...state.dataDokumenKabkot,
            loading: false,
            error: false,
            data: action.payload,
          },
        };
      case GET_DOKUMEN_KABKOT_FAIL:
        return {
          ...state,
          dataDokumenKabkot: {
            ...state.dataDokumenKabkot,
            loading: false,
            error: action.payload,
          },
      };
			case GET_DOKUMEN_KECAMATAN:
        return {
          ...state,
          dataDokumenKecamatan: {
            ...state.dataDokumenKecamatan,
            loading: true,
            error: false,
          },
        };
      case GET_DOKUMEN_KECAMATAN_SUCCESS:
        return {
          ...state,
          dataDokumenKecamatan: {
            ...state.dataDokumenKecamatan,
            loading: false,
            error: false,
            data: action.payload,
          },
        };
      case GET_DOKUMEN_KECAMATAN_FAIL:
        return {
          ...state,
          dataDokumenKecamatan: {
            ...state.dataDokumenKecamatan,
            loading: false,
            error: action.payload,
          },
      };
      default:
        return state;
    }
  };
  
  export default reducer;
  